// extracted by mini-css-extract-plugin
export default {"aboveHeaderSlot":"foocbt"};